import { handleStatus500 } from 'api/Utility/HandleStatus500'
import AxiosInitializer from 'api/Utility/AxiosInitializer'
import getToken from 'lib/authentication/GetToken'
import apiWrapper from 'api/Utility/ApiWrapper'
import type {
  CreateGroupRequestPayload,
  GetGroupsPayload,
  DeleteGroupPayload,
  GetGroupPayload,
  ValidateGroupNamePayload,
  UpdateGroupRequestPayload,
} from 'api/ApiActions/Groups/GroupType'

const axiosRequest = (extraParams: any = {}) => {
  const params = {
    token: getToken(),
    paramsSerializerConfig: true,
    ...extraParams,
  }

  return AxiosInitializer({
    ...params,
  })
}

const CreateGroupURL = '/participant_segments'
const ValidateGroupName = '/participant_segments/check_segment_name'
const GetGroupsURL = '/participant_segments'
const DeleteGroupURL = '/participant_segments'
const GetGroupURL = '/participant_segments'

export const getCreateGroupPayload = (groupName: string, segmentId: string) => {
  const params = {
    payload: {
      data: {
        attributes: {
          segments: {
            name: groupName,
          },
        },
      },
    },
    segmentId,
  }

  return params
}

export const getUpdateGroupPayload = (tempSegmentId: string) => {
  return {
    data: {
      attributes: {
        clone: {
          temp_segment_id: tempSegmentId,
          confirmed: true,
        },
      },
    },
  }
}

export const ascGroupsParam = {
  filters: { sort: { name: 'asc' } },
}

const filterGroupEndPoint = {
  createGroup: (data: CreateGroupRequestPayload) => {
    const { segmentId } = data
    return axiosRequest().put(`${CreateGroupURL}/${segmentId}`, data.payload)
  },
  getGroups: (params: GetGroupsPayload) => {
    return axiosRequest().get(GetGroupsURL, {
      params: { per_page: 9999, ...params },
    })
  },
  deleteGroup: (data: DeleteGroupPayload) => {
    const { segmentId } = data
    const deleteGroupURLWithID = `${DeleteGroupURL}/${segmentId}`
    return axiosRequest().delete(deleteGroupURLWithID)
  },
  getGroup: (data: GetGroupPayload) => {
    const { segmentId } = data
    const getGroupURLWithID = `${GetGroupURL}/${segmentId}`
    return axiosRequest().get(getGroupURLWithID)
  },
  validateGroupName: (data: ValidateGroupNamePayload) => {
    const { name } = data
    return axiosRequest().get(ValidateGroupName, {
      params: { name },
    })
  },
  getProjectsInAGroup: (data: { groupId: string }) => {
    const { groupId } = data
    const URL = `/participant_segments/${groupId}/projects`
    return axiosRequest().get(URL)
  },
  updateGroup: (data: UpdateGroupRequestPayload) => {
    const { segmentId } = data
    const URL = `/participant_segments/${segmentId}/clone_filters`

    return axiosRequest().put(URL, data.payload)
  },
}

const filterGroupsAPI = {
  createGroup: (params: CreateGroupRequestPayload) =>
    apiWrapper({
      endPoint: filterGroupEndPoint.createGroup,
      params,
      errorFailureAction: handleStatus500,
    }),
  getGroups: (params = {}) =>
    apiWrapper({
      endPoint: filterGroupEndPoint.getGroups,
      params,
      errorFailureAction: handleStatus500,
    }),
  deleteGroup: (params: DeleteGroupPayload) =>
    apiWrapper({
      endPoint: filterGroupEndPoint.deleteGroup,
      params,
      errorFailureAction: handleStatus500,
    }),
  getGroup: (params: DeleteGroupPayload) =>
    apiWrapper({
      endPoint: filterGroupEndPoint.getGroup,
      params,
      errorFailureAction: handleStatus500,
    }),
  validateGroupName: (params: ValidateGroupNamePayload) =>
    apiWrapper({
      endPoint: filterGroupEndPoint.validateGroupName,
      params,
      errorFailureAction: handleStatus500,
    }),
  getProjectsInAGroup: (params: { groupId: string | undefined }) =>
    apiWrapper({
      endPoint: filterGroupEndPoint.getProjectsInAGroup,
      params,
      errorFailureAction: handleStatus500,
    }),
  updateGroup: (params: UpdateGroupRequestPayload) =>
    apiWrapper({
      endPoint: filterGroupEndPoint.updateGroup,
      params,
      errorFailureAction: handleStatus500,
    }),
}

export default filterGroupsAPI
